import { SETMINORDERDELIVERYPRICE } from "../../../redux/features/CartData";
import { setSelectedAddress } from "../../../redux/features/CheckoutAddress";
import { Dispatch } from "redux";
export const setErrorCustom = (setError: any, val: any, message: any) => {
    setError(val, { type: "custom", message: message, });
}

export const returnAddressFormJson = (getValues: any) => {
    // let fullAddress = getValues("house_no") ? `${getValues("house_no")}, ${getValues("full_address")}` : getValues("full_address")
    let jsonFormData = {
        address_type: getValues("address_type"),
        full_address: getValues("full_address"),
        street_name: getValues("street_name"),
        // state: getValues("state"),
        city: getValues("city"),
        country: getValues("country"),

        lattitude: getValues('lattitude'),
        longitude: getValues('longitude'),
        zip_code: getValues("zip_code"),
        house_no: getValues("house_no"),
        id: getValues("id"),
    }
    return jsonFormData;
}

// @@ set store minium order fees and delivery charge
export const setMinimumPriceAndAddressData = (dispatch: Dispatch, miniumPrice: any, selectedData: any) => {
    dispatch(SETMINORDERDELIVERYPRICE(miniumPrice));
    dispatch(setSelectedAddress(selectedData ? selectedData : {}))
}


